import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BatchNumbersModel } from 'src/app/core/models/masters/goodissuereceipt.model';
import { SerialModel } from 'src/app/core/models/masters/serial.model';
import { WrapperStandardFilter } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { GenericListView } from 'src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';

@Component({
  selector: 'app-batch-serial-popup',
  templateUrl: './batch-serial-popup.component.html',
  styleUrls: ['./batch-serial-popup.component.css']
})
export class BatchSerialPopupComponent extends GenericListView<any> {
  local_data: any;
  batchSerialData:any;
  isBatch = true;
  availableQuantity!: number;
  inventoryTransfer = false;
  code="";
  constructor(agenericRepository: GenericService<any>, router: Router,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>,
    public snackbarService: BaseService<any>) {
  
    super(agenericRepository, router);
    if (data.data) { this.local_data = data.data; }
    else {
      this.local_data = data
    }

    console.log('localDataggg',data)
    this.isBatch = this.local_data.manageBatchNumbers == "Y";
    this.availableQuantity = +this.local_data.quantity;

    this.setListViewDataSourceURL = "IssueForProduction/GetItemBatchSerialService";
   
    if (data.data) {

      if (data.component == "InventoryTransfer" && this.local_data.isViewMode) {
        this.setDisplayedColumnsNamesList = ['serialNo', 'BatchNo', 'FromQuantity', 'ToQuantity', 'binLocationAllocation', 'sysNumber', 'intSerialNumber', 'mfrSerialNumber', 'expiryDate', 'mfrDate'];
      }
      else {
        this.setDisplayedColumnsNamesList = ['checkbox', 'serialNo', 'BatchNo', 'Quantity', 'enterQuantity', 'binLocationAllocation', 'sysNumber', 'intSerialNumber', 'mfrSerialNumber', 'expiryDate', 'mfrDate'];

      }
    } else {
      this.setDisplayedColumnsNamesList = ['checkbox', 'serialNo', 'BatchNo', 'Quantity', 'enterQuantity', 'binLocationAllocation', 'sysNumber', 'intSerialNumber', 'mfrSerialNumber', 'expiryDate', 'mfrDate'];
    }
  if (data.data) {
      if (data.component == "InventoryTransfer"){
        this.getRequestData.SortColumn = "ItemCode";
    this.getRequestData.PageRecordCount = 100;
    this.getRequestData.RequestData = [];
    const requestData: any = {}
    requestData['itemCode'] = this.local_data.itemCode;
    let filter1: WrapperStandardFilter = new WrapperStandardFilter();
    filter1.Key = 'WarehouseCode';
    filter1.OperatorType = "startswith";
    filter1.Value = this.local_data.fromWarehouseCode;
    let filter2: WrapperStandardFilter = new WrapperStandardFilter();
    filter2.Key = 'WAREHOUSECODE';
    filter2.OperatorType = "ENDSWITH";
    filter2.Value = this.local_data.fromWarehouseCode;
    requestData.FILTERS = [filter1, filter2];
    this.getRequestData.RequestData.push(requestData); 
      }
      else {
        this.getRequestData.SortColumn = "ItemCode";
        this.getRequestData.PageRecordCount = 100;
        this.getRequestData.RequestData = [];
        const requestData: any = {}
        requestData['itemCode'] = this.local_data.itemCode;
        let filter1: WrapperStandardFilter = new WrapperStandardFilter();
        filter1.Key = 'WarehouseCode';
        filter1.OperatorType = "startswith";
        filter1.Value = this.local_data.warehouseCode;
        let filter2: WrapperStandardFilter = new WrapperStandardFilter();
        filter2.Key = 'WAREHOUSECODE';
        filter2.OperatorType = "ENDSWITH";
        filter2.Value =  this.local_data.warehouseCode;
        requestData.FILTERS = [filter1, filter2];
        this.getRequestData.RequestData.push(requestData);
      }
  }else{
      
    this.getRequestData.SortColumn = "ItemCode";
    this.getRequestData.PageRecordCount = 100;
    this.getRequestData.RequestData = [];
    const requestData: any = {}
    requestData['itemCode'] = this.local_data.itemCode;
    let filter1: WrapperStandardFilter = new WrapperStandardFilter();
    filter1.Key = 'WarehouseCode';
    filter1.OperatorType = "startswith";
    filter1.Value = this.local_data.warehouseCode;
    let filter2: WrapperStandardFilter = new WrapperStandardFilter();
    filter2.Key = 'WAREHOUSECODE';
    filter2.OperatorType = "ENDSWITH";
    filter2.Value =  this.local_data.warehouseCode;
    requestData.FILTERS = [filter1, filter2];
    this.getRequestData.RequestData.push(requestData);
  }
   
    if (data.component) {


      if (data.component == "InventoryTransfer") {
        this.inventoryTransfer = true;
        if (!this.local_data.isViewMode) {
          (async () => {
            {
              await this.PopulateListView();
             
              console.log("res",this.getListViewDataSource);
              this.setListViewDataSource = [...new Map(this.getListViewDataSource.map((item) => [item.batchSerialNumber, item])).values()]
              console.log("resdddd",this.getListViewDataSource);
              this.batchSerialData=this.getListViewDataSource;
            }
          })();
        }else{
        if (this.local_data.serialNumbers) {
          let serialBatchNumbers = this.local_data.serialNumbers;

          let arr = serialBatchNumbers
            .filter((item: any) => item.quantity > 0) // Filter items with quantity > 0
            .map((item: any) => ({
              ...item, // Keep existing properties if needed
              batchSerialNumber: item.internalSerialNumber,
              toWarehouseQty: item.quantity,
              fromWarehouseQty: -item.quantity, // Ensure negative value for fromWarehouseQty
            }));

          this.setListViewDataSource = arr;
          this.batchSerialData=this.getListViewDataSource;
        }
        else if (this.local_data.batchNumbers) {
          let serialBatchNumbers = this.local_data.batchNumbers;

          let arr = serialBatchNumbers
            .filter((item: any) => item.quantity > 0) // Filter items with quantity > 0
            .map((item: any) => ({
              ...item, // Keep existing properties if needed
              batchSerialNumber: item.batchNumber,
              toWarehouseQty: item.quantity,
              fromWarehouseQty: -item.quantity, // Ensure negative value for fromWarehouseQty
            }));

          this.setListViewDataSource = arr;
          this.batchSerialData=this.getListViewDataSource;
        }

      }


      }
      else if (data.component == "InventoryCounting" ) {

        (async () => {
          if (!this.local_data.isViewMode) {
            await this.PopulateListView();
            this.setListViewDataSource = [...new Map(this.getListViewDataSource.map((item) => [item.batchSerialNumber, item])).values()]
            let serialBatchNumbers = this.local_data.inventoryCountingbatchNumbers || this.local_data.inventoryCountingserialNumbers;
            serialBatchNumbers = serialBatchNumbers// Filter items with quantity > 0
              .map((item: any) => ({
                ...item, // Keep existing properties if needed
                batchSerialNumber: item.internalSerialNumber,
                // Ensure negative value for fromWarehouseQty
              }));
            this.setListViewDataSource = [
              ...new Map(this.getListViewDataSource.map((item) => [item.batchSerialNumber, item])).values(),
              ...serialBatchNumbers
            ];
            this.batchSerialData=this.getListViewDataSource;
          }

          if (this.local_data.isSerialed || this.local_data.isBatched) {
           // await this.PopulateListView();
            const serialBatchNumbers = this.local_data.inventoryCountingBatchNumbers || this.local_data.inventoryCountingSerialNumbers;
            if (this.local_data.isViewMode) {
              this.setListViewDataSource = serialBatchNumbers;
              this.batchSerialData=this.getListViewDataSource;
              this.getListViewDataSource.forEach(el => {
                el['isChecked'] = true;
                if (this.local_data.isSerialed) {
                  el.batchSerialNumber = el.internalSerialNumber
                }
              });
            }
             else {
              const serialBatchNumbers = this.local_data.inventoryCountingBatchNumbers || this.local_data.inventoryCountingSerialNumbers;
              this.setListViewDataSource = serialBatchNumbers;
              this.batchSerialData=this.getListViewDataSource;
              serialBatchNumbers.forEach((item: any, i: number) => {
                let index = this.getListViewDataSource.findIndex(el => el.batchSerialNumber == (item?.InternalSerialNumber || item?.BatchNumberProperty || item.batchNumber));
                if (index !== -1) {
                  this.getListViewDataSource[index]['isChecked'] = true;
                  this.getListViewDataSource[index].onHandQty = (item.Quantity || item.quantity);
                }
              })
              this.availableQuantity = this.local_data.quantity - this.totalEnteredQty;
              this.setListViewDataSource = this.getListViewDataSource.sort((a, b) => {
                const checkedA = a.isChecked ? 1 : 0;
                const checkedB = b.isChecked ? 1 : 0;
                return checkedB - checkedA;
              });
            }
          }
          else {
           await this.PopulateListView();
            const serialBatchNumbers = this.local_data.inventoryCountingBatchNumbers || this.local_data.inventoryCountingSerialNumbers;
            //this.setListViewDataSource =serialBatchNumbers;
            serialBatchNumbers.forEach((item: any, i: number) => {
              let index = this.getListViewDataSource.findIndex(el => el.batchSerialNumber == (item?.InternalSerialNumber || item?.BatchNumberProperty || item.batchNumber));
              if (index !== -1) {
                this.getListViewDataSource[index]['isChecked'] = true;
                this.getListViewDataSource[index].onHandQty = (item.Quantity || item.quantity);
              }
            })
            this.availableQuantity = this.local_data.quantity - this.totalEnteredQty;
            this.setListViewDataSource = this.getListViewDataSource.sort((a, b) => {
              const checkedA = a.isChecked ? 1 : 0;
              const checkedB = b.isChecked ? 1 : 0;
              return checkedB - checkedA;
            });
            this.batchSerialData=this.getListViewDataSource;
          }
        })();


      }
      else if (data.component == "InventoryPosting" ) {

        (async () => {
          if (!this.local_data.isViewMode) {
            await this.PopulateListView();
            this.setListViewDataSource = [...new Map(this.getListViewDataSource.map((item) => [item.batchSerialNumber, item])).values()]
            let serialBatchNumbers = this.local_data.inventoryPostingbatchNumbers || this.local_data.inventoryPostingserialNumbers;
            serialBatchNumbers = serialBatchNumbers// Filter items with quantity > 0
              .map((item: any) => ({
                ...item, // Keep existing properties if needed
                batchSerialNumber: item.internalSerialNumber,
                // Ensure negative value for fromWarehouseQty
              }));
            this.setListViewDataSource = [
              ...new Map(this.getListViewDataSource.map((item) => [item.batchSerialNumber, item])).values(),
              ...serialBatchNumbers
            ];
            this.batchSerialData=this.getListViewDataSource;
          }

          if (this.local_data.isSerialed || this.local_data.isBatched) {
           // await this.PopulateListView();
            const serialBatchNumbers = this.local_data.inventoryPostingBatchNumbers || this.local_data.inventoryPostingSerialNumbers;
            if (this.local_data.isViewMode) {
              this.setListViewDataSource =serialBatchNumbers;
              this.getListViewDataSource.forEach(el => {
                el['isChecked'] = true;
                if (this.local_data.isSerialed) {
                  el.batchSerialNumber = el.internalSerialNumber
                }
              });
              this.batchSerialData=this.getListViewDataSource;
            } 
            else {
              
              const serialBatchNumbers = this.local_data.inventoryPostingBatchNumbers || this.local_data.inventoryPostingSerialNumbers;
              this.setListViewDataSource =serialBatchNumbers;
              serialBatchNumbers.forEach((item: any, i: number) => {
                let index = this.getListViewDataSource.findIndex(el => el.batchSerialNumber == (item?.InternalSerialNumber || item?.BatchNumberProperty || item.batchNumber));
                if (index !== -1) {
                  this.getListViewDataSource[index]['isChecked'] = true;
                  this.getListViewDataSource[index].onHandQty = (item.Quantity || item.quantity);
                }
              })
              this.availableQuantity = this.local_data.quantity - this.totalEnteredQty;
              this.setListViewDataSource = this.getListViewDataSource.sort((a, b) => {
                const checkedA = a.isChecked ? 1 : 0;
                const checkedB = b.isChecked ? 1 : 0;
                return checkedB - checkedA;
              });
              this.batchSerialData=this.getListViewDataSource;
            }
          }
          else {
            await this.PopulateListView();
            const serialBatchNumbers = this.local_data.inventoryPostingBatchNumbers || this.local_data.inventoryPostingSerialNumbers;
            //this.setListViewDataSource =serialBatchNumbers;
            serialBatchNumbers.forEach((item: any, i: number) => {
              let index = this.getListViewDataSource.findIndex(el => el.batchSerialNumber == (item?.InternalSerialNumber || item?.BatchNumberProperty || item.batchNumber));
              if (index !== -1) {
                this.getListViewDataSource[index]['isChecked'] = true;
                this.getListViewDataSource[index].onHandQty = (item.Quantity || item.quantity);
              }
            })
            this.availableQuantity = this.local_data.quantity - this.totalEnteredQty;
            this.setListViewDataSource = this.getListViewDataSource.sort((a, b) => {
              const checkedA = a.isChecked ? 1 : 0;
              const checkedB = b.isChecked ? 1 : 0;
              return checkedB - checkedA;
            });
            this.batchSerialData=this.getListViewDataSource;
          }
        })();


      }
    } else {
      (async () => {
        if (!this.local_data.isViewMode) {
          await this.PopulateListView();
          this.setListViewDataSource = [...new Map(this.getListViewDataSource.map((item) => [item.batchSerialNumber, item])).values()]
          this.batchSerialData=this.getListViewDataSource;
        }


        if (this.local_data.isSerialed || this.local_data.isBatched) {
          await this.PopulateListView();
          const serialBatchNumbers = this.local_data.serialNumbers || this.local_data.batchNumbers;
          if (this.local_data.isViewMode) {
            this.setListViewDataSource = serialBatchNumbers;
            this.getListViewDataSource.forEach(el => {
              el['isChecked'] = true;
              if (this.local_data.isSerialed) {
                el.batchSerialNumber = el.internalSerialNumber
              }
            });
            this.batchSerialData=this.getListViewDataSource;
          } else {

            serialBatchNumbers.forEach((item: any, i: number) => {
              let index = this.getListViewDataSource.findIndex(el => el.batchSerialNumber == (item?.InternalSerialNumber || item?.BatchNumberProperty || item.batchNumber));
              if (index !== -1) {
                this.getListViewDataSource[index]['isChecked'] = true;
                this.getListViewDataSource[index].onHandQty = (item.Quantity || item.quantity);
              }
            })
            this.availableQuantity = this.local_data.quantity - this.totalEnteredQty;
            this.setListViewDataSource = this.getListViewDataSource.sort((a, b) => {
              const checkedA = a.isChecked ? 1 : 0;
              const checkedB = b.isChecked ? 1 : 0;
              return checkedB - checkedA;
            });
            this.batchSerialData=this.getListViewDataSource;
          }
        }
      })();
    }
    this.batchSerialData=this.getListViewDataSource;

    console.log('this.batchSerialData',this.batchSerialData)
   
 
    if(this.isBatch){

     
      setTimeout(()=>{
        this.showSelectBatch()
       },1000) 

    }
    else{

     setTimeout(()=>{
      this.showSelectSerial()
     },1000) 

    }
  }


  filterData(){
    if(this.code!=""){
     this.setListViewDataSource=this.batchSerialData.filter((i:any)=> {
     return  (i.batchSerialNumber && i.batchSerialNumber.toLowerCase().includes(this.code.toLowerCase())) ||
     (i.batchNumber && i.batchNumber.toLowerCase().includes(this.code.toLowerCase()))
    });
  }
  else if(this.code==""){
    this.setListViewDataSource=this.batchSerialData;
  }
}
  selectBatchSerial(event: any, i: number) {
    this.getListViewDataSource[i]['isChecked'] = event.checked;
    this.getListViewDataSource[i].onHandQty='';
  }

  validateAndUpdateQty(qtyElement: any, i: number) {
    qtyElement.value = qtyElement.value < 1 ? "" : qtyElement.value;
    let enteredQty = +qtyElement.value;

    this.getListViewDataSource[i]['onHandQty'] = +qtyElement.value;
    if (this.totalEnteredQty > this.local_data.quantity) {
      this.snackbarService.showMessage("Batch Quantity Can not be more than required quantity", "X");
      this.getListViewDataSource[i]['onHandQty'] = 0;
      qtyElement.value = 0;
      this.availableQuantity = this.local_data.quantity - this.totalEnteredQty;
      this.getListViewDataSource[i].isChecked = false;
    } else if (enteredQty > this.getListViewDataSource[i].quantity) {
      this.snackbarService.showMessage("You have entered more than the available quantity.", "X");
      this.getListViewDataSource[i]['onHandQty'] = 0;
      qtyElement.value = 0;
      this.getListViewDataSource[i].isChecked = false;
    }
    else {
      if (this.totalEnteredQty == 0) {
        this.availableQuantity = this.local_data.quantity;
      } else {
        this.availableQuantity = this.local_data.quantity - this.totalEnteredQty;
      }
    }
  }

  get totalEnteredQty() {
    return this.getListViewDataSource.reduce((sum, item) => sum + (item.onHandQty || 0), 0);
  }

  autoSelectSerial() {
  
   

   for (let i = 0; i < this.local_data.quantity; i++) {
    if (this.availableQuantity > 0) {

     this.getListViewDataSource[i].isChecked = true;
   this.validateAndUpdateQty({ value: 1 }, i);

    }
       
   
   

    }
  }

  showSelectSerial() {
  
   
    // this.setListViewDataSource = this.getListViewDataSource.filter((el) => {
    //   let matched = false;
    
    //   if (this.local_data.serialNumbers) {
    //     this.local_data.serialNumbers.forEach((element: any) => {
    //       if (
    //         el.batchSerialNumber === element.internalSerialNumber ||
    //         el.batchSerialNumber === element.batchNumber
    //       ) {
    //         el.isChecked = true;
    //         el.onHandQty = this.local_data.baseRef?'':element.quantity;
    //         matched = true;
    //       }
    //     });
    //   }
    
    //   return this.local_data.baseRef?matched:true; // Keep only matched items
    // });

       this.getListViewDataSource.map((el) => {
      let matched = false;
    
      if (this.local_data.serialNumbers) {
        this.local_data.serialNumbers.forEach((element: any) => {
          if (
            el.batchSerialNumber === element.internalSerialNumber 
          ) {
            el.isChecked = true;
            el.onHandQty = element.quantity;
           matched = true;
          }
        });
      }
    
     return this.local_data.baseRef?matched:true; // Keep only matched items
    });
  }

  showSelectBatch() {
 
 
     this.getListViewDataSource.map((el) => {
      let matched = false;
    
      if (this.local_data.batchNumbers) {
        this.local_data.batchNumbers.forEach((element: any) => {
          if (
            el.batchSerialNumber === element.batchNumberProperty ||
            el.batchSerialNumber === element.batchNumber
          ) {
            el.isChecked = true;
            el.onHandQty = this.local_data.baseRef?'':element.quantity;
            matched = true;
          }
        });
      }
    
      return this.local_data.baseRef?matched:true; // Keep only matched items
    });

  }

  autoSelectBatch() {
    this.getListViewDataSource.forEach((el, i) => {
      if (this.availableQuantity > 0) {
        if (this.getListViewDataSource[i].quantity < this.availableQuantity) {
          this.getListViewDataSource[i].isChecked = true;
          this.validateAndUpdateQty({ value: this.getListViewDataSource[i].quantity }, i);
        } else {
          this.getListViewDataSource[i].isChecked = true;
          this.validateAndUpdateQty({ value: this.availableQuantity }, i);
        }
      }
    })
  }

  saveBatchSerial() {
    
    let saveSerialBatchArray: any[] = [];
    if (this.isBatch) {
      let saveBatchArray: BatchNumbersModel[] = []
      const selectedRows = this.getListViewDataSource.filter(item => item.isChecked);
      selectedRows.forEach((item, i) => {
        let batchItem = new BatchNumbersModel();
        batchItem.itemCode = this.local_data.itemCode;
        batchItem.batchNumberProperty = item.batchSerialNumber || item.batchNumber;
        batchItem.quantity = item.onHandQty;
        // batchItem.OnHandQty = item.onHandQty;
        saveBatchArray.push(batchItem);
      })
      saveSerialBatchArray = saveBatchArray;
    } else {
      let saveSerialArray: SerialModel[] = []
      const selectedRows = this.getListViewDataSource.filter(item => item.isChecked);
      selectedRows.forEach((item, i) => {
        let serialItem = new SerialModel();
        serialItem.itemCode = this.local_data.itemCode;
        serialItem.internalSerialNumber = item.batchSerialNumber;
        serialItem.quantity = item.onHandQty;
        saveSerialArray.push(serialItem);
      })
      saveSerialBatchArray = saveSerialArray;
    }

    if (saveSerialBatchArray.reduce((sum, item) => sum + item.quantity, 0) == this.local_data.quantity) {
      this.dialogRef.close({ event: true, value: saveSerialBatchArray });
    } else {
      this.snackbarService.showMessage("Please Use All the Quantity", "X");
    }
  }
}
